import { Component, Inject, OnDestroy, OnInit } from "@angular/core";
import {
  UntypedFormBuilder,
  UntypedFormControl,
  UntypedFormGroup,
  Validators,
} from "@angular/forms";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";

@Component({
    selector: "app-download",
    templateUrl: "./download.component.html",
    styleUrls: ["./download.component.scss"],
    standalone: false
})
export class DownloadDialogComponent implements OnInit, OnDestroy {
  constructor(
    private fb: UntypedFormBuilder,
    public dialogRef: MatDialogRef<DownloadDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    if (data) {
      this.id = data.id;
      this.title = data.title;
      if (data.type) {
        this.type = data.type;
      }
      this.fullReport = data.fullReport;
      this.containsOnlyTables = data.containsOnlyTables;
      this.showMessage = data.showMessage;
    }
  }

  public downloadForm!: UntypedFormGroup;

  private reportExportOptions = [
    //  { value: "pdf", title: "PDF (Acrobat)" },
    { value: "docx", title: "WORD" },
  ];
  private reportTableChartExportOptions = [
    //  { value: "pdf", title: "PDF (Acrobat)" },
    { value: "docx", title: "WORD" },
    { value: "xlsx", title: "EXCEL" },
  ];
  private tableChartExportOptions = [
    //  { value: "pdf", title: "PDF (Acrobat)" },
    { value: "docx", title: "WORD" },
    { value: "xlsx", title: "EXCEL" },
    { value: "csv", title: "CSV" },
  ];
  private highChartExportOptions = [
    // { value: "pdf", title: "PDF (Acrobat)" },
    { value: "docx", title: "WORD" },
  ];
  public exportOptions: any = [];
  title!: string;
  id!: number;
  type?: string;
  fullReport!: boolean;
  showMessage!: boolean;
  chartID?: number;
  containsOnlyTables?: boolean = false;
  onNoClick(): void {
    this.dialogRef.close();
  }
  onConfirmClick(): void {
    const title = this.downloadForm.get("name")!.value;
    const type = this.downloadForm.get("type")!.value;
    this.dialogRef.close({
      result: true,
      save: false,
      title: title,
      type: type,
    });
  }
  saveAndExport(): void {
    const title = this.downloadForm.get("name")!.value;
    const type = this.downloadForm.get("type")!.value;
    this.dialogRef.close({
      result: true,
      title: title,
      save: true,
      type: type,
    });
  }

  ngOnInit(): void {
    this.downloadForm = this.fb.group({
      id: new UntypedFormControl(this.id),
      name: new UntypedFormControl(this.title, [Validators.required]),
      type: new UntypedFormControl("docx", [Validators.required]),
    });

    if (this.fullReport) {
      this.exportOptions = this.reportExportOptions;
      if (this.containsOnlyTables) {
        this.exportOptions = this.reportTableChartExportOptions;
      }
    } else {
      if (this.type == "Table" || this.type == "List") {
        this.exportOptions = this.tableChartExportOptions;
      } else {
        this.exportOptions = this.highChartExportOptions;
      }
    }

    if (this.exportOptions.length == 1) {
      this.downloadForm.controls["type"].disable();
    }
  }
  ngOnDestroy(): void {}
}
